/**
 * Determines if user is a student by ensuring permissions = 0 and not faculty
 * @param {Object} user - The compound_user object
 * @returns {Boolean} Is the user a plain student
 */
export function isStudent(user) {
    return (user?.permissions ?? 0) === 0 && !user.is_faculty;
}

/**
 * Determines if the user is faculty
 * @param {Object} user - The compound_user object 
 * @returns {Boolean} Is the user marked as faculty
 */
export function isFaculty(user) {
    return ((user?.permissions ?? 0) === 0 && user.is_faculty) ?? false;
}